(function($) {
	'use strict';

	$(document).ready(function() {
        
        if(
            $('body').hasClass('page-template-product-option') ||
            $('body').hasClass('page-template-cart') ||
            $('body').hasClass('page-template-page-checkout') ||
            $('body').hasClass('page-template-page-login') ||
            $('body').hasClass('page-template-page-register') ||
            $('body').hasClass('page-template-page-reset-password') ||
            $('body').hasClass('page-template-page-my-account')
        ){
            iFrameResize({log:false, checkOrigin:false}, '.favshop');
        }
        
	});
    
    

})(jQuery);